import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api from "../lib/api";

/**
 * Callback de Google OAuth — Google redirige a /auth/google?code=...&state=...
 * Intercambia el code con el backend y obtiene el session_token.
 *
 * REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
 */
export default function AuthCallback({ onAuth }) {
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const search = new URLSearchParams(window.location.search);
    const code = search.get("code");
    const state = search.get("state");
    const error = search.get("error");

    if (error) {
      navigate(`/login?auth_error=${encodeURIComponent(error)}`, { replace: true });
      return;
    }
    if (!code || !state) {
      navigate("/login", { replace: true });
      return;
    }

    const redirectUri = window.location.origin + "/auth/google";

    const exchange = async () => {
      try {
        const { data } = await api.post("/auth/google/callback", {
          code,
          state,
          redirect_uri: redirectUri,
        });
        localStorage.setItem("vetcomer_token", data.token);
        if (onAuth) onAuth(data.user);
        navigate("/", { replace: true, state: { user: data.user } });
      } catch (err) {
        const message = err?.response?.data?.detail || "No se pudo completar el inicio de sesión";
        navigate(`/login?auth_error=${encodeURIComponent(message)}`, { replace: true });
      }
    };

    exchange();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="min-h-screen flex items-center justify-center bg-zinc-50" data-testid="auth-callback-page">
      <div className="text-center">
        <div className="w-8 h-8 border-2 border-zinc-300 border-t-zinc-900 rounded-full animate-spin mx-auto mb-4" />
        <p className="text-sm text-zinc-500">Iniciando sesión con Google…</p>
      </div>
    </div>
  );
}
